import { render } from "./IconUsers.vue.js?vue&type=template&id=6721ce4f!=!../../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./IconUsers.vue?vue&type=template&id=6721ce4f"
const script = {}

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__